import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import StrategyHome from './pages/StrategyHome';
import InstitutionalPage from './pages/InstitutionalPage';
import AfricaPage from './pages/AfricaPage';
import AdminInquiries from './pages/AdminInquiries';
import Platforms from './pages/strategy/Platforms';
import Capital from './pages/strategy/Capital';
import Roadmap from './pages/strategy/Roadmap';
import Teaser from './pages/strategy/Teaser';
import Leadership from './pages/Leadership';

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => { document.documentElement.style.scrollBehavior = 'auto'; };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<StrategyHome />} />
        <Route path="/strategy/platforms" element={<Platforms />} />
        <Route path="/strategy/capital" element={<Capital />} />
        <Route path="/strategy/roadmap" element={<Roadmap />} />
        <Route path="/strategy/teaser" element={<Teaser />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/institutional" element={<InstitutionalPage />} />
        <Route path="/africa" element={<AfricaPage />} />
        <Route path="/admin/inquiries" element={<AdminInquiries />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
